import { Container, Graphics, Sprite } from 'pixi.js';
import type { PublicPlayerAppearance } from '@push.io/shared';
import { AssetManager } from '../AssetManager.js';

export class FlagLayer {
  readonly container: Container;
  private sprite: Sprite | null = null;
  private mask: Graphics = new Graphics();
  private currentFlag: string | null = null;
  private currentRadius: number = 0;

  constructor() {
    this.container = new Container();
    this.container.addChild(this.mask);
    this.container.mask = this.mask;
    // Flags replace the base color visually; transparency would tint them
    // with whichever base color the player currently has equipped.
    this.container.alpha = 1;
  }

  update(appearance: PublicPlayerAppearance | null, radius: number): void {
    const flagId = appearance?.flagId ?? null;
    if (flagId === this.currentFlag && radius === this.currentRadius) return;

    this.currentFlag = flagId;
    this.currentRadius = radius;

    if (this.sprite) {
      this.container.removeChild(this.sprite);
      this.sprite.destroy({ texture: false });
      this.sprite = null;
    }

    if (!flagId) {
      this.container.visible = false;
      return;
    }

    const texture = AssetManager.getFlagTexture(flagId);
    if (!texture) {
      this.container.visible = false;
      return;
    }

    this.sprite = new Sprite(texture);
    const bodySize = radius * 2;
    this.sprite.width = bodySize;
    this.sprite.height = bodySize;
    this.sprite.anchor.set(0.5);
    this.sprite.position.set(0, 0);

    this.mask.clear();
    this.mask.circle(0, 0, radius);
    this.mask.fill({ color: 0xffffff });

    this.container.addChild(this.sprite);
    this.container.visible = true;
  }

  setVisible(visible: boolean): void {
    this.container.visible = visible;
  }

  destroy(): void {
    if (this.sprite) {
      this.container.removeChild(this.sprite);
      this.sprite.destroy({ texture: false });
      this.sprite = null;
    }
    this.mask.clear();
    this.mask.destroy();
    this.container.removeChildren();
  }
}
